import React from 'react'
import * as Sentry from '@sentry/react'

// Auth localStorage keys, mirrored from useNostrLogin.js. Kept inline
// here so the ErrorBoundary can recover without importing the hook
// (the hook may be the source of the error we're catching).
const AUTH_KEYS = [
  'verdant_pubkey',
  'verdant_login_type',
  'verdant_nsec_hex',
  'verdant_ncryptsec',
]
const SS_DECRYPTED_KEY = 'verdant_decrypted_key'

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('[Verdant] uncaught render error', error, info)
    // Forward to Sentry with the React component stack so the dashboard's
    // Component Trace panel populates. Sentry.captureException is a safe
    // no-op when Sentry isn't initialized (no DSN set locally), so this
    // doesn't break dev builds.
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info.componentStack } },
    })
  }

  reload = () => {
    window.location.reload()
  }

  signOutAndReload = () => {
    try {
      for (const k of AUTH_KEYS) localStorage.removeItem(k)
      sessionStorage.removeItem(SS_DECRYPTED_KEY)
    } catch { /* noop */ }
    window.location.reload()
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div className="error-boundary">
        <div className="error-boundary-card">
          <h2>Something went wrong.</h2>
          <p>
            Verdant hit an unexpected error. Your votes and account are safe —
            try a reload, or sign out if the same error keeps coming back.
          </p>
          <pre className="error-boundary-detail">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <div className="error-boundary-actions">
            <button type="button" className="btn btn-primary" onClick={this.reload}>
              Reload
            </button>
            <button type="button" className="btn btn-secondary" onClick={this.signOutAndReload}>
              Sign out and reload
            </button>
          </div>
        </div>
      </div>
    )
  }
}
